import axios from "axios"
import {
  GET_GATEKEEPER_PROFILE_API_URL,
  UPDATE_GATEKEEPER_PROFILE_API_URL,
} from "@/helpers/constants/constants"
const gatekeeper = {
  getProfile() {
    return axios.get(GET_GATEKEEPER_PROFILE_API_URL)
  },

  updateProfile(slug, data) {
    if (!slug) throw "updateProfile: received empty slug"
    return axios.patch(`${UPDATE_GATEKEEPER_PROFILE_API_URL}${slug}/`, data)
  },
}

export default gatekeeper
